import { useEffect, useState } from 'react';
import { useWarehouses } from '../../hooks/useDelivery';
import { Input } from '../ui/input';

export function WarehousePicker({
  cityRef,
  value,
  onSelect,
}: {
  cityRef: string | null;
  value: string | null;
  onSelect: (warehouseRef: string, address: string) => void;
}) {
  const { data: warehouses = [], isLoading } = useWarehouses(cityRef);
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState(false);

  // Нове місто — старий пошуковий запит більше не стосується справи.
  // cityRef isn't read in the body, it's the reset trigger itself.
  // biome-ignore lint/correctness/useExhaustiveDependencies: see comment above
  useEffect(() => {
    setQuery('');
    setSelected(false);
  }, [cityRef]);

  if (!cityRef) return null;
  if (isLoading) return <p className="mono-label mt-2">ЗАВАНТАЖЕННЯ ВІДДІЛЕНЬ…</p>;
  if (warehouses.length === 0)
    return <p className="mt-2 text-[13px] text-muted">Відділень не знайдено.</p>;

  const filtered = warehouses.filter((warehouse) =>
    warehouse.address.toLowerCase().includes(query.trim().toLowerCase()),
  );
  // Без пошукового поля список — єдиний спосіб обрати відділення, тож
  // ховати його після вибору нема сенсу (нема де ще побачити свій вибір).
  const showList = warehouses.length <= 5 || !selected;

  return (
    <div className="mt-2">
      {warehouses.length > 5 && (
        <Input
          placeholder="Пошук відділення (вулиця, номер)"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setSelected(false);
          }}
          className="mb-2"
        />
      )}
      {showList && (
        <div className="max-h-48 overflow-y-auto border border-line">
          {filtered.length === 0 ? (
            <p className="px-4 py-3 text-[13px] text-muted">Нічого не знайдено.</p>
          ) : (
            filtered.map((warehouse) => (
              <button
                key={warehouse.ref}
                type="button"
                onClick={() => {
                  onSelect(warehouse.ref, warehouse.address);
                  setQuery(warehouse.address);
                  setSelected(true);
                }}
                className={
                  'block w-full border-b border-line-soft px-4 py-3 text-left text-[13px] last:border-b-0 cursor-pointer ' +
                  (value === warehouse.ref
                    ? 'border-l-2 border-l-accent bg-line-soft text-ink'
                    : 'text-muted hover:text-ink')
                }
              >
                {warehouse.address}
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
